import * as React from 'react';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { createTheme, styled } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { useTranslate } from '@mui/internal-core-docs/i18n';
import ThemeViewer, { useItemIdsLazy } from 'docs/src/modules/components/ThemeViewer';
import { blue, grey } from '@mui/internal-core-docs/branding';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Box": Box, "@mui/material/Divider": Divider, "@mui/material/styles": { createTheme, styled }, "@mui/material/FormControlLabel": FormControlLabel, "@mui/material/Switch": Switch, "@mui/internal-core-docs/i18n": { useTranslate }, "docs/src/modules/components/ThemeViewer": ThemeViewer, "@mui/internal-core-docs/branding": { blue, grey } } } });
export default ClientProvider;
